import { useMemo } from "react";

import Box from "ds/components/Box";
import { UserGuideGroupEnriched } from "shared/UserGuides/types";

import UserGuideGroupChapterSection from "./ChapterSection";

type UserGuideGroupProps = {
  userGuideGroup: UserGuideGroupEnriched;
  groupId?: string;
};

const UserGuideGroup = ({ userGuideGroup, groupId }: UserGuideGroupProps) => {
  const { guideId: initiallyExpandedGuideId, chapterId: initiallyExpandedChapterId } = useMemo(
    () =>
      userGuideGroup.chapters
        ?.flatMap((chapter) =>
          chapter.guides.map((guide) => ({
            guideId: guide.id,
            chapterId: chapter.id,
            isCompleted: guide.isCompleted,
          }))
        )
        .find((guide) => !guide.isCompleted) ?? { guideId: "", chapterId: "" },

    [userGuideGroup.chapters]
  );

  return (
    <Box direction="column" gap="xx-large" grow="1" scrollable>
      {userGuideGroup.chapters?.map((chapter) => (
        <UserGuideGroupChapterSection
          key={chapter.id}
          chapter={chapter}
          groupId={groupId}
          initiallyCollapsed={initiallyExpandedChapterId !== chapter.id}
          initiallyExpandedGuideId={initiallyExpandedChapterId && initiallyExpandedGuideId}
        />
      ))}
    </Box>
  );
};

export default UserGuideGroup;
